import ten99 from 'Agent/1099s/ducks/1099';
import ten99_v2 from 'Agent/1099s/ducks/1099_v2';

export default {
  ten99,
  ten99_v2,
};
